export const types = {
  GET_STATISTICS: 'statistics'
}

export default {
  BASE_URL: '',
  api: [
    {
      name: types.GET_STATISTICS,
      desc: '获取首页统计数据',
      method: 'GET',
      path: '//crmMember/statistics'
    },
    {
      name: 'getActsInFloor',
      desc: '获取首页集采活动楼层',
      method: 'GET',
      path: '/om/cenPurActivity/getActsInFloor'
    },
    {
      name: 'showActivities',
      desc: '获取集采活动',
      method: 'POST',
      path: '/om/cenPurActivity/showActivities'
    },
    {
      name: 'getActDetail',
      desc: '获取集采活动详情',
      method: 'GET',
      path: '/om/cenPurActivity/getActDetail'
    },
    {
      name: 'toBuyProds',
      desc: '获取集采订单详情',
      method: 'POST',
      path: '/om/cenPurActivity/toBuyProds'
    },
    {
      name: 'createOrder',
      desc: '提交集采订单',
      method: 'POST',
      path: '/om/cenPurActivity/createOrder'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/home/home.js